export default "__VITE_ASSET__DlCunw_n__"